
import React, { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

// Import the components
import AuthHeader from '@/components/auth/AuthHeader';
import AuthLoader from '@/components/auth/AuthLoader';
import AuthContainer from '@/components/auth/AuthContainer';
import MicrosoftAuthButton from '@/components/auth/MicrosoftAuthButton';

const Auth = () => {
  const { signInWithMicrosoft, user, session, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [processingOAuth, setProcessingOAuth] = useState(false);

  // Process OAuth redirects
  useEffect(() => {
    if (location.hash && location.hash.includes('access_token')) {
      console.log('Processing OAuth redirect in Auth component');
      setProcessingOAuth(true);
      
      const timer = setTimeout(() => {
        setProcessingOAuth(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [location]);

  // Handle successful authentication
  useEffect(() => {
    // Only redirect if we have a user, session, not loading, and not processing OAuth
    if (user && session && !loading && !processingOAuth) {
      console.log('User authenticated, redirecting to /teams');
      navigate('/teams');
    }
  }, [user, session, loading, navigate, processingOAuth]);

  const handleMicrosoftSignIn = async () => {
    try {
      console.log('Initiating Microsoft sign in...');
      await signInWithMicrosoft();
    } catch (error) {
      console.error('Microsoft sign in error:', error);
      toast.error('Failed to sign in with Microsoft. Please try again.');
    }
  };

  if (loading || processingOAuth) {
    return <AuthLoader message={processingOAuth ? 'Completing sign in...' : 'Loading...'} />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-mesh p-4">
      <div className="w-full max-w-md animate-fade-in opacity-0" style={{ animationDelay: '150ms', animationFillMode: 'forwards' }}>
        <AuthHeader />
        
        <AuthContainer title="M365 demo - Governance Hub" description="Sign in with your Microsoft account to continue">
          <div className="mt-2 mb-6">
            <MicrosoftAuthButton onClick={handleMicrosoftSignIn} />
          </div>
        </AuthContainer>
      </div>
    </div>
  );
};

export default Auth;
